import ForwardDocumentComponent from '@/components/Pages/ForwardDocument.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/report/:reportId/folder/:folderId/forward',
  props: true,
  name: RouteNames.ForwardDocument,
  component: ForwardDocumentComponent,
};

export default route;
